export default __webpack_public_path__ + "static/B04-1f5ce8fe6160ea24cf9fc51e0c3ee97e.png";